.tag {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-code);
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
  white-space: nowrap;
}

/* Sizes */
.sm {
  padding: 2px 8px;
  font-size: var(--text-xs);
}

.md {
  padding: 4px 12px;
  font-size: var(--text-sm);
}

/* Variants */
.default {
  background: var(--bg-elevated);
  color: var(--text-secondary);
  border: 1px solid var(--border);
}

.cyan {
  background: rgba(0, 240, 255, 0.1);
  color: var(--accent-cyan);
  border: 1px solid rgba(0, 240, 255, 0.3);
}

.magenta {
  background: rgba(255, 45, 123, 0.1);
  color: var(--accent-magenta);
  border: 1px solid rgba(255, 45, 123, 0.3);
}

.green {
  background: rgba(57, 255, 20, 0.1);
  color: var(--accent-green);
  border: 1px solid rgba(57, 255, 20, 0.3);
}

.tag:hover {
  filter: brightness(1.2);
}
